import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/comics";

interface BreadcrumbItem {
  name: string;
  href?: string;
}

interface BreadcrumbProps {
  items?: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const location = useLocation();
  const pathParts = location.pathname.split("/").filter(Boolean);

  const autoItems: BreadcrumbItem[] = [
    { name: "首页", href: "/" },
    ...pathParts.map((part, i) => {
      const isLast = i === pathParts.length - 1;
      const href = isLast ? undefined : `/${pathParts.slice(0, i + 1).join("/")}`;

      if (part === "category") {
        const slug = pathParts[i + 1];
        const cat = categories.find((c) => c.slug === slug);
        return { name: cat?.name || slug, href };
      }
      if (part === "comic") {
        return { name: "漫画详情", href };
      }

      if (part === "about") return { name: "关于我们", href };

      const cat = categories.find((c) => c.slug === part);
      if (cat) return { name: `分类：${cat.name}`, href };

      return { name: part, href };
    }),
  ];

  const breadcrumbItems = items || autoItems;

  return (
    <nav aria-label="面包屑导航" className="w-full max-w-7xl mx-auto px-4 md:px-6 py-3">
      <ol className="flex items-center flex-wrap text-sm text-foreground-600 gap-1">
        {breadcrumbItems.map((item, index) => (
          <li key={index} className="flex items-center whitespace-nowrap">
            {index > 0 && (
              <span className="mx-2 text-foreground-400" aria-hidden="true">/</span>
            )}
            {item.href ? (
              <Link
                to={item.href}
                className="text-foreground-500 hover:text-primary-500 transition-colors duration-200"
              >
                {item.name}
              </Link>
            ) : (
              <span className="text-foreground-900 font-medium">{item.name}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}